"use strict";

var _classCallCheck = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ChangelogBuffer = /*#__PURE__*/function () {
  function ChangelogBuffer(_ref) {
    var value = _ref.value,
        _ref$timeout = _ref.timeout,
        timeout = _ref$timeout === void 0 ? 3 : _ref$timeout,
        _ref$flusher = _ref.flusher,
        flusher = _ref$flusher === void 0 ? function () {
      return null;
    } : _ref$flusher;

    _classCallCheck(this, ChangelogBuffer);

    this.initValue = value;
    this.timeout = timeout * 1000;
    this.flusher = flusher;
    this.timer = null;
  }

  _createClass(ChangelogBuffer, [{
    key: "flush",
    value: function flush(value) {
      var succeeded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.flusher({
        fromValue: String(this.initValue),
        toValue: String(value),
        succeeded: succeeded
      });
      this.initValue = value;
      this.timer = null;
    }
  }, {
    key: "update",
    value: function update(value) {
      var _this = this;

      var succeeded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(function () {
        return _this.flush(value, succeeded);
      }, this.timeout);
    }
  }]);

  return ChangelogBuffer;
}();

exports.default = ChangelogBuffer;